import React from 'react';

import Home from './templates/home';

const NowaIwiczna: React.SFC = () => <Home></Home>;

export default NowaIwiczna;
